export const compressImageToTargetSize = (file, targetSizeKb = 100) => {
  return new Promise((resolve, reject) => {
    const targetSizeBytes = targetSizeKb * 1024;

    if (!file.type.startsWith("image/")) {
      resolve(file);
      return;
    }

    // Already small enough.
    if (file.size <= targetSizeBytes) {
      resolve(file);
      return;
    }

    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Failed to read the image file."));
    reader.onload = (event) => {
      const img = new Image();
      img.onerror = () => reject(new Error("Failed to load the image."));
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;

        const outputType =
          file.type === "image/png" || file.type === "image/webp"
            ? file.type
            : "image/jpeg";

        const drawAndExport = (w, h, quality) =>
          new Promise((res) => {
            canvas.width = w;
            canvas.height = h;
            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(img, 0, 0, w, h);
            canvas.toBlob(
              (blob) => res(blob),
              outputType,
              quality
            );
          });

        (async () => {
          let quality = 0.9;
          let blob = await drawAndExport(width, height, quality);

          // Step 1: reduce quality first.
          while (blob && blob.size > targetSizeBytes && quality > 0.1) {
            quality -= 0.1;
            blob = await drawAndExport(width, height, quality);
          }

          // Step 2: if still too big, progressively scale down dimensions.
          while (blob && blob.size > targetSizeBytes && (width > 100 || height > 100)) {
            width = Math.round(width * 0.85);
            height = Math.round(height * 0.85);
            quality = 0.8;
            blob = await drawAndExport(width, height, quality);
            while (blob && blob.size > targetSizeBytes && quality > 0.1) {
              quality -= 0.1;
              blob = await drawAndExport(width, height, quality);
            }
          }

          if (!blob) {
            reject(new Error("Failed to compress the image."));
            return;
          }

          const compressedFile = new File(
            [blob],
            file.name.replace(/\.\w+$/, outputType === "image/png" ? ".png" : ".jpg"),
            { type: outputType, lastModified: Date.now() }
          );

          resolve(compressedFile);
        })();
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  });
};
